export default "__VITE_ASSET__Btw635Od__"